import * as React from 'react';
import Group from 'sail/Group';
import Button from 'sail/Button';
import {useAccount, useLocation} from 'docs/data';
import {FormattedMessage, defineMessages} from 'react-intl';
import {normalizeHostname} from 'docs/util';
import {BillingPricePicker} from 'docs/interactive/IntegrationBuilder/components/left-col/PricePicker';

export const messages = defineMessages({
  signIn: {
    id: 'docsShell.ib.signIn.when.logged.out',
    description: 'Link to signing into an account',
    defaultMessage: 'Sign in',
  },
});

const LoggedOutView = ({message}) => {
  const {account} = useAccount();
  const {location} = useLocation();
  return (
    <Group direction="horizontal" spacing={24} alignItems="center">
      <Button
        color="white"
        label={message}
        href={normalizeHostname(
          `https://dashboard.stripe.com/login?redirect=${location.toString()}`,
          account.hosts,
        )}
        target="_self"
      />
    </Group>
  );
};

export function BillingPricePickerWithLoggedOutView() {
  const {account} = useAccount();
  const merchant = account.merchant;

  return merchant?.isLoggedIn ? (
    <BillingPricePicker />
  ) : (
    <LoggedOutView message=<FormattedMessage {...messages.signIn} /> />
  );
}
